import { getCutToSizeMaterials, getIsSending } from '../../store/cut-to-size/reducers'
import React, { Component, forwardRef } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import GoBack from '../global/GoBack'
import Button from '../global/Button'
import Translation from '../global/Translation'
import { requestPreOrder } from '../../store/cut-to-size/actions'
import ElaborationDetails from './ElaborationDetails'
import { ReactComponent as Visit } from '../../assets/img/icons/visit.svg'
import { ReactComponent as Add } from '../../assets/img/icons/add.svg'

import { BudgetMessages, Messages } from './CutToSizeMaps'
import { showToastNotification } from '../../store/toast-notifications/actions'
import DatePicker from 'react-datepicker'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import LocalizedLink from '../global/LocalizedLink'
import FileInput from '../global/FileInput'
import Alerts from '../alerts/Alerts'
import { requiredAdvancePayment } from '../../store/login/reducers'

const BLUEPRINT_FILE_TYPE = 'BX02'
const LABELS_FILE_TYPE = 'BX10'
const EMAIL_FILE_TYPE = 'BX03'


const mapStateToProps = state => {
    return {
        materials: getCutToSizeMaterials(state),
        isSending: getIsSending(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        requestPreOrder: (formData, callback, onCommentValidationError) => dispatch(requestPreOrder(formData, callback, true, onCommentValidationError)),
        showToastNotification: (text = '', type = 'none', duration = 10000) => dispatch(showToastNotification(text, type, duration)),
    }
}

export const ACCEPTED_EXT = {
    REQUIRED_BLUEPRINT:[
        'image/*',
        'application/pdf',
        '.dxf','.dwg'
    ],
    BLUEPRINT_FILE_TYPE:[
        'image/svg+xml',
        'image/jpeg',
        'image/png',
        'application/dxf',
        'application/pdf'
    ],
    LABELS_FILE_TYPE:[
        'image/jpeg',
        'image/png',
        'application/dxf',
        'application/pdf'
    ],
    EMAIL_FILE_TYPE:[
        'application/msword',
        'application/pdf',
        'application/octet-stream',
        'message/rfc822',
        'application/vnd.ms-outlook','msg','.msg'
    ]
}

const Separator =  <div style={{marginBlock: '24px', height: '1px', backgroundColor: '#E2E4E9', width: '100%'}}/>

class CutToSizeFormPreOrder extends Component {

    state = {
        currentProjectOptions: [],
        selectedProject: null,
        deadline: null,
        selectedFiles: {
            REQUIRED_BLUEPRINT:null,
            // BLUEPRINT_FILE_TYPE:null,
            LABELS_FILE_TYPE:null,
            EMAIL_FILE_TYPE:null
        },
        purchaseOrder: '',
        additionalFiles: {},
        showExceedFileSizeAlert: false,
        comments: '',
        commentError: false,
        formResetKey: 0,
        showSelectFileType: false,
        preorderId: null,
        showCreatedModal: false,
        isDirectCustomer: false
    }



    getFileOptions = () => {
        const fileOptions = []
        const addedFiles = this.state.additionalFiles

        if (!addedFiles.LABELS_FILE_TYPE) {
            fileOptions.push(
                {
                    label:<div>
                        <i className="far fa-tags mx-2 w-25 text-center"/>{this.props.intl.formatMessage(BudgetMessages.LABELS_FILE_TYPE)}
                    </div>,
                    value:'LABELS_FILE_TYPE'
                }
            )
        }
        if (!addedFiles.EMAIL_FILE_TYPE) {
            fileOptions.push(
                {
                    label:<div>
                        <i className="far fa-envelope mx-2 w-25 text-center"/>{this.props.intl.formatMessage(BudgetMessages.EMAIL_FILE_TYPE)}
                    </div>,
                    value:'EMAIL_FILE_TYPE'
                }
            )
        }
        return fileOptions
    }

    getMinDate = () => moment().add(3, 'days')

    getSelectedFiles = () => {
        const selectedFiles = {}
        selectedFiles[BLUEPRINT_FILE_TYPE] = this.state.selectedFiles.REQUIRED_BLUEPRINT
        // if (this.state.selectedFiles.BLUEPRINT_FILE_TYPE) selectedFiles[BLUEPRINT_FILE_TYPE] = this.state.selectedFiles.BLUEPRINT_FILE_TYPE
        if (this.state.selectedFiles.LABELS_FILE_TYPE) selectedFiles[LABELS_FILE_TYPE] = this.state.selectedFiles.LABELS_FILE_TYPE
        if (this.state.selectedFiles.EMAIL_FILE_TYPE) selectedFiles[EMAIL_FILE_TYPE] = this.state.selectedFiles.EMAIL_FILE_TYPE

        return selectedFiles
    }

    componentDidMount() {
        this.props.materials['BUDGET']['pre_order']['projects'].forEach(project => {
            this.state.currentProjectOptions.push({
                label: this.props.intl.formatMessage(BudgetMessages[project]),
                value: project
            })
        })

        this.forceUpdate()
    }

    disableSendButton = () => {
        return !this.state.selectedProject || !this.state.deadline || !this.state.comments || !this.state.selectedFiles.REQUIRED_BLUEPRINT || this.props.isSending
    }

    onFileChange = async (files, type) => {
        this.state.selectedFiles[type] = files ? files[0] : null
        this.forceUpdate()
    }

    addAdditionalFile = (fileType) => {
        const key = uuidv4()
        this.state.additionalFiles[fileType] = true
        // this.forceUpdate()
    }

    delAdditionalFile = fileType => {
        // const fileType = this.state.additionalFiles[key]
        delete this.state.selectedFiles[fileType]
        delete this.state.additionalFiles[fileType]
        this.forceUpdate()
    }


    submitData = () => {
        this.setState({ commentError: false })
        const formData = new FormData()
        formData.append('project', this.state.selectedProject)
        formData.append('deadline', this.state.deadline)
        formData.append('comment', this.state.comments)
        formData.append('purchase_order', this.state.purchaseOrder)
        const files = this.getSelectedFiles()
        const fileKeys = []
        Object.entries(files).forEach(([type, file]) => {
            const key = `cts_preorder_file_${type}_0`
            fileKeys.push(key)
            formData.append(key, file)
        })
        formData.append('file_keys', fileKeys)

        this.props.requestPreOrder(formData, this.showNotification, () => this.setState({ commentError: true }))
    }

    showNotification = (response) => {
        this.setState(state => ({
            selectedProject: null,
            deadline: null,
            selectedFiles: {
                REQUIRED_BLUEPRINT: null,
                LABELS_FILE_TYPE: null,
                EMAIL_FILE_TYPE: null
            },
            purchaseOrder: '',
            additionalFiles: {},
            comments: '',
            commentError: false,
            showSelectFileType: false,
            showExceedFileSizeAlert: false,
            formResetKey: state.formResetKey + 1,
            showCreatedModal: true,
            preorderId: response.preorderId,
            isDirectCustomer: response.isDirectCustomer
        }))
    }

    render() {
        const { selectedProject, currentProjectOptions, additionalFiles } = this.state
        const { intl, selectedElaboration } = this.props
        if (!selectedElaboration) return null

        const fileOptions = this.getFileOptions()
        const DesiredDatePicker = forwardRef(({ value, onClick }, ref) => {
            return (
                <div onClick={onClick} className="form-control d-flex justify-content-between align-items-center"
                     style={{cursor: 'pointer'}}
                >
                    {
                        !!value ? (
                            <React.Fragment>
                                {value}
                                <Visit/>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="form-control-placeholder">
                                    {intl.formatMessage(Messages.SET_DEADLINE)}
                                </div>
                                <Visit/>
                            </React.Fragment>
                        )
                    }
                </div>
            )
        })

        return (
            <section className="cut_to_size_budget">
                <div className="cut_to_size__go_back mt-4 mb-3">
                    <LocalizedLink routeId={'ROUTE_CUT_TO_SIZE'} header={true} queryString={''} params={{'outlet':''}}>
                        <GoBack
                            text={intl.formatMessage(Messages.BACK_SELECT_ELABORATED_TYPE)}
                            dataCY={'product_detail__go_back'}
                        />
                    </LocalizedLink>
                </div>

                <div className="container form" >
                    <div className="row">
                        <div className="col-12 col-lg-7">
                            <div style={{ width: '100%' }}>
                                <ElaborationDetails
                                    id={selectedElaboration}                         
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 group__form">
                            <div className="group__title"><Translation id="ask_for_custom_quotation" defaultMessage="Request your custom quotation" /></div>
                            <div className="group__description"><Translation id="quotation_header_text" defaultMessage="Fill in the fields, tell us what you need and we will send you a no-obligation quote. If you decide to go ahead, we will send you the technical drawing so you can confirm your order." /></div>
                            {Separator}
                            {/**************** SELECT PROJECT **********************/}
                            <div className="group__input">
                                <label htmlFor="project-select" className="form-label">
                                    <Translation id="project-type" defaultMessage="Project type" />*
                                </label>
                                <div className="contain__select--project">
                                    <Select
                                        id="project-select"
                                        clearable={false}
                                        placeholder={this.props.intl.formatMessage(Messages.CHOOSE_PROJECT_TYPE)}
                                        options={currentProjectOptions}
                                        value={selectedProject}
                                        onChange={selectedOption => this.setState({selectedProject: selectedOption.value})}
                                    />
                                </div>
                            </div>

                            {/**************** DEADLINE **********************/}
                            <div className="group__input">
                                <label htmlFor="input-deadline" className="form-label">
                                    <Translation id="deadline" defaultMessage="Preferred delivery date" />*
                                </label>
                                <div className="contain__set-deadline">
                                    <DatePicker
                                        id="input-deadline"
                                        selected={this.state.deadline}
                                        onChange={date => this.setState({deadline: date})}
                                        // minDate={this.props.selectedCenter == 1100 && !this.slaDate ? getNextWorkingDay(this.props.minDeliveryDate) :  getNextWorkingDay(1)}
                                        autoComplete="off"
                                        minDate={this.getMinDate()}
                                        onKeyDown={e => e.preventDefault()}
                                        dropdownMode="select"
                                        customInput={<DesiredDatePicker />}
                                    />
                                </div>
                            </div>

                            {/**************** PURCHASE ORDER **********************/}
                            <div className="group__input">
                                <label htmlFor="input-po" className="form-label">
                                    <Translation id="purchase-order" defaultMessage="Your reference" />
                                </label>
                                <div className="contain__input-po">
                                    <input
                                        type="text"
                                        id="input-po1"
                                        placeholder={this.props.intl.formatMessage({id: 'purchase-order'})}
                                        value={this.state.purchaseOrder}
                                        onChange={e => this.setState({purchaseOrder: e.target.value})}
                                        className={`form-control`}
                                        maxLength="132"

                                    />
                                </div>
                            </div>


                            {/**************** ADJUNTAR DOCUMENTO **********************/}
                            <div className="group__input" >
                                <label htmlFor="attach_packaging_document_file" className="form-label mb-0">
                                    <Translation id="attached_documents" defaultMessage="Attached documents" />
                                </label>
                                <div className="group__label">
                                    <Translation id="allowed_formats" defaultMessage="Allowed formats: .PNG .JPG .PDF .DOC .DWG .DXF .EML .MSG (Max. 10MB)" />
                                </div>
                                {/*<div className="row align-items-center mb-2">*/}
                                <div className="group__file">
                                    {/*<div className="col-3 form-label" style={{fontSize:'90%'}}>*/}
                                    <div className="group__file__label">
                                        <Translation id="blueprint" defaultMessage="Blueprint"/>*:
                                    </div>
                                    <FileInput key={this.state.formResetKey}
                                               className="cts_file_input"
                                               onChange={file => this.onFileChange(file, 'REQUIRED_BLUEPRINT')}
                                    >
                                        <Translation id="select_file" defaultMessage="Select file"/>
                                    </FileInput>
                                </div>

                                {
                                    Object.keys(additionalFiles).map(fileType => {
                                        const key = 'ad_f_' + fileType
                                        return (
                                            // <div key={key} className="row align-items-center mb-2">
                                            //     <div className="col-3 form-label" style={{fontSize:'90%'}}>
                                            //         {intl.formatMessage(BudgetMessages[fileType])}
                                            //     </div>
                                            //     <div className="col-7 pr-0">
                                            //         <div className="attach-file">
                                            //             <input
                                            //                 id="attach_packaging_document_file"
                                            //                 type="file"
                                            //                 accept={ACCEPTED_EXT[fileType].join()}
                                            //                 onChange={e => this.onFileChange(e, fileType)}
                                            //                 // accept="image/jpeg, image/png, application/pdf"
                                            //             />
                                            //         </div>
                                            //     </div>
                                            //     <div className="col-2">
                                            //         <div className="attach-file justify-content-center"
                                            //              style={{fontSize:'16px', cursor:'pointer'}}
                                            //              onClick={() => this.delAdditionalFile(fileType)}
                                            //         >
                                            //             <i className="far fa-trash"/>
                                            //         </div>
                                            //     </div>
                                            // </div>
                                            <div className="group__file" key={key}>
                                                <div className="group__file__label">{intl.formatMessage(BudgetMessages[fileType])}:</div>
                                                <FileInput
                                                    className="cts_file_input"
                                                    onChange={file => {
                                                        if (file) this.onFileChange(file, fileType)
                                                        else this.delAdditionalFile(fileType)
                                                    }}
                                                >
                                                    <Translation id="select_file" defaultMessage="Select file" />
                                                </FileInput>
                                            </div>
                                        )
                                    })
                                }


                                {/*<div className="field-info">*/}
                                {/*    <Translation id="attached_document_info" defaultMessage={"Add here the information you want to include within the packaging. May involve expenses and associated costs."} />*/}
                                {/*</div>*/}


                                {/**************** ADD ADDITIONAL FILE **********************/}
                                {fileOptions.length > 0 && (
                                    <div className="row">
                                        <div className="col-6 group__input mb-0 mt-2">
                                            <div className="additional-file"
                                                 onClick={() => this.setState({showSelectFileType: true})}
                                            >
                                                {/*<i className="fa fa-plus" style={{fontWeight:500}}/>*/}
                                                <Add/>
                                                &nbsp;&nbsp;
                                                <Translation id="add-additional-file" defaultMessage="Add additional file"/>
                                            </div>
                                        </div>
                                        { this.state.showSelectFileType && (
                                            <div className="col-6 group__input">
                                                <div className="contain__select--project">
                                                    <Select
                                                        placeholder={this.props.intl.formatMessage(Messages.CHOOSE_FILE_TYPE)}
                                                        options={fileOptions}
                                                        onChange={selectedOption => {
                                                            this.addAdditionalFile(selectedOption.value)
                                                            this.setState({showSelectFileType: false})
                                                        }}
                                                        onBlur={() => this.setState({showSelectFileType: false})}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/*<div className="field-info mb-1">*/}
                                {/*    <Translation style={{all:"revert"}} id="exceed_file_limit" defaultMessage={`The file has a limit of {fileLimit} MB`} values={{ fileLimit: FILE_LIMIT }} />*/}
                                {/*</div>*/}
                            </div>


                            {/**************** COMENTARIOS **********************/}
                            <div className="group__input">
                                <label htmlFor="input-comments" className="form-label">
                                    <Translation id="comment" defaultMessage="Comments" />*
                                </label>
                                <textarea
                                    className="form-control"
                                    id="input-comments"
                                    rows="3"
                                    maxLength="255"
                                    value={this.state.comments}
                                    aria-invalid={this.state.commentError}
                                    aria-describedby={this.state.commentError ? 'input-comments-error' : undefined}
                                    onChange={e => {
                                        e && this.setState({ comments: e.target.value, commentError: false })
                                    }}
                                />
                                {this.state.commentError && (
                                    <div id="input-comments-error">
                                        <Alerts
                                            status="danger"
                                            element={<Translation id="comment_max_length" defaultMessage="The comment may not be greater than {max} characters." values={{ max: 255 }} />}
                                        />
                                    </div>
                                )}
                            </div>
                            {/*<div>*/}
                            {/*    <span className="field-info"><strong><Translation id="mandatory_field_meaning" defaultMessage="* Means mandatory field" /></strong></span>*/}
                            {/*</div>*/}
                            {Separator}

                            {/**************** SOLICITAR PRESUPUESTO **********************/}
                            <div>
                                <Button
                                    // customClass="bt-dark gt"
                                    customClass="bt-inverted"
                                    dataCY="product_detail__add"
                                    disabled={this.disableSendButton()}
                                    onClick={() => (this.submitData())}
                                >
                                    <Translation id="ask_for_quotation" defaultMessage="Ask for a quotation" />
                                </Button>
                            </div>
                        </div>{' '}
                  
                        {/*{this.state.showExceedFileSizeAlert && (*/}
                        {/*    <FloatingAlert*/}
                        {/*        warningMessage={<Translation id="exceed_file_limit" defaultMessage={`The file has a limit of {fileLimit} MB`} values={{ fileLimit: FILE_LIMIT }} />}*/}
                        {/*        onClose={() => {*/}
                        {/*            this.setState({ showExceedFileSizeAlert: false })*/}
                        {/*        }}*/}
                        {/*    />*/}
                        {/*)}*/}

                        {
                            this.state.showCreatedModal && (
                                <div className="preorder_created_modal" onClick={() => this.setState({showCreatedModal: false})}>
                                    <div className="modal-content" onClick={(e) => {e.stopPropagation()}}>

                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', columnGap: '16px'}}>
                                            <i className="fas fa-check-circle" style={{color:'#36A596', fontSize: '1.6em'}}/>
                                            <div className="success-text big">
                                                <Translation id="susesfully_sent_quotation" defaultMessage="Quotation successfully submitted!"/>
                                            </div>
                                            <i className="fal fa-times fa-2x"
                                               style={{position: 'absolute', right: '32px', top: '16px', cursor: 'pointer'}}
                                               onClick={(e) => this.setState({showCreatedModal: false})}
                                            />
                                        </div>

                                        <div style={{paddingInline: '16px', marginBlock: '16px', height: '1px', backgroundColor: '#E2E4E9', width: '100%'}}/>

                                        <div className="success-text">
                                            {this.state.isDirectCustomer ?
                                                <Translation id="susesfully_sent_quotation_text1" defaultMessage="Your quote request has been created. The technical department will review it and you will receive a quote soon."/>
                                                :
                                                <FormattedHTMLMessage id="susesfully_sent_quotation_text1_required_payment" defaultMessage="Your request has been created. The technical department will review it and you will soon receive the quotation and plan. This quote will be <b>valid for 30 calendar days</b> for acceptance. Once this period has elapsed, <b>it will automatically expire</b>."/>
                                            }
                                        </div>
                                        <br/>
                                        <div className="success-text">
                                            <Translation id="susesfully_sent_quotation_text2" defaultMessage="You can check its status at any time from your Quotation request history in your personal area."/>
                                        </div>

                                        <div style={{paddingInline: '16px', marginBlock: '16px', height: '1px', backgroundColor: '#E2E4E9', width: '100%'}}/>

                                        <div className="mt-2 mb-2">
                                            <LocalizedLink routeId="ROUTE_PROFILE" params={{ filter: 'pre-orders-cts-details', open: this.state.preorderId }}>
                                                <Button customClass="bt-dark gt xt-pd" onClick={(e) => e.stopPropagation()}>
                                                    <Translation id="view_quotation_status" defaultMessage="View my quotation status"/>
                                                </Button>
                                            </LocalizedLink>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </section>
        )
    }
}
export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CutToSizeFormPreOrder)
)
